import React from "react"
import Dropdown from "@/components/partials/Dropdown"
import { trans } from "@/_providers/Translation"

function Filter(props) {
  const handleSearch = (e) => {
    props.handleSearch(e.target.value)
  }

  const handleDevice = (data) => {
    // data.id is set when a device is picked, empty when the field is cleared
    if (data.id || data.name === "") {
      props.handleDevice(data.id || "")
    }
  }

  return (
    <form className="catalogue-filter" onSubmit={(e) => e.preventDefault()}>
      <div className="col">
        <Dropdown
          url="aswo/find-device"
          inputPlaceholder={trans("catalogue.devicePlaceholder")}
          renderText={(data) =>
            `${data.name || ""} ${data.number || ""}`.trim()
          }
          onChange={handleDevice}
          ref={props.deviceDropdownRef}
        />
      </div>
      <div className="col">
        <input
          type="search"
          name="search"
          value={props.search}
          onChange={handleSearch}
          onKeyUp={handleSearch}
          placeholder={trans("catalogue.searchPlaceholder")}
        />
      </div>
    </form>
  )
}

export default Filter
